import { Box, Heading, Skeleton, Text } from '@chakra-ui/react';
import { Education } from '../generated/graphql';

interface IInfoProps {
    education?: Array<Education | null> | null;
    locations?: Array<string | null> | null;
    loading: boolean;
}
export default function Info({ education, loading, locations }: IInfoProps) {
    return (
        <Box w="full">
            <Heading size="md" mb="2" pl="25px">
                Info 📖
            </Heading>
            <Box
                border="1px solid"
                borderColor={'midnight.50'}
                borderRadius={{ lg: 'xl' }}
                backgroundColor="white"
                p="24px"
                mb="24px"
            >
                {education?.map((education, index) => (
                    <>
                        <Heading size="sm" mb="2">
                            {education?.school ? 'Education' : ''}
                        </Heading>
                        <Skeleton isLoaded={!loading} mb="4">
                            <Text fontSize="md">{education?.school ?? ''}</Text>
                        </Skeleton>
                        <Heading size="sm" mb="2">
                            {education?.major ? 'Major' : ''}
                        </Heading>
                        <Skeleton isLoaded={!loading} mb="4">
                            <Text fontSize="md">{education?.major ?? ''}</Text>
                        </Skeleton>
                        <Heading size="sm" mb="2">
                            {education?.graduation_date ? 'Graduation Date' : ''}
                        </Heading>
                        <Skeleton isLoaded={!loading} mb="4">
                            <Text fontSize="md">{education?.graduation_date ?? ''}</Text>
                        </Skeleton>
                    </>
                ))}

                <Heading size="sm" mb="2">
                    Looking for roles in...
                </Heading>
                <Skeleton isLoaded={!loading}>
                    <Text fontSize="md" textTransform="capitalize">
                        {locations && getWorkingLocations(locations)}
                    </Text>
                </Skeleton>
            </Box>
        </Box>
    );
}

function getWorkingLocations(locations?: Array<string | null>) {
    let availableLocations = '';
    for (const location of locations ?? []) {
        // Replace dash with space i.e Los-Angeles -> Los Angeles
        availableLocations += location?.replace(/-/g, ' ') + ', ';
        if (location === locations?.[locations.length - 1]) {
            availableLocations = availableLocations.slice(0, -2);
        }
    }
    return availableLocations;
}
